<template>
	<div class="xlSecretManage">
		<!-- <div class="filters">
			<el-form>
				<el-form-item>
					<el-select :disabled="!disabled" v-model="gardenId" filterable @change="onChangeGarden"
						placeholder="请选择园区或输入关键词" style="width: 240px">
						<el-option v-for="(item,index) in gardenList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div> -->
		<el-card class="form" style="min-height:600px;">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm">
				<el-form-item class="formBox" label="所在园区:" prop="text">
					<el-select :disabled="!disabled" v-model="gardenId" filterable @change="onChangeGarden"
						placeholder="请选择园区或输入关键词" style="width: 240px">
						<el-option v-for="(item,index) in gardenList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item class="formBox" label="园区密钥:" prop="text">
					<el-input placeholder="未设置密钥" suffix-icon="el-icon-key" v-model="ruleForm.text" :autofocus="!disabled"
						:disabled=disabled style="width: 240px">
					</el-input>
					<el-button style="display:flex" type="primary" v-if="secret && disabled" @click.native="disabled=false">修改密钥
					</el-button>
					<el-button type="primary" v-else-if="disabled" @click.native="disabled=false">设置密钥</el-button>
					<el-button type="primary" v-if="!disabled" @click="showDialog('ruleForm')">保存</el-button>
					<el-button type="info" v-if="!disabled" @click.native="cancel">取消</el-button>
				</el-form-item>
				<el-form-item label="修改时间:">
					<label v-if="secret&&secret.operTime">{{ secret.operTime | time}}</label>
					<label v-else>-</label>
				</el-form-item>
				<label class="c-red">* 删除密钥请联系管理员处理</label>
			</el-form>
		</el-card>
		<el-dialog title="确认园区密钥信息" :visible.sync="dialogVisible" :close-on-click-modal="false" :show-close="false" center
			top="5px !important" width="800px">
			<el-form :label-width="require('@/config/enum').c_ws8" :label-suffix="require('@/config/enum').c_colon">
				<el-form-item label="所属园区:">
					<label>{{gardenName}}</label>
				</el-form-item>
				<el-form-item label="园区秘钥:">
					<label>{{ruleForm.text}}</label>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="dialogVisible = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click.native="saveSecretByGarden">{{$t('lang.btn_confirm')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	/**
	 *@ClassName:xlSecretManage
	 *@Description:星朗密钥管理
	 *@author:杜斌
	 *@Copyright:格众科技
	 *@date:2021-09-01
	 */
	export default {
		// name: '/manage/main.xlSecretManage',
		data() {
			return {
				gardenId: null,
				gardenList: [],
				gardenName: '',
				secret: null, // 接口返回的密钥
				disabled: true, // 输入框禁用状态

				dialogVisible: false, // 对话框显示隐藏
				ruleForm: {
					text: '', // 输入框绑定文本
				},
				rules: {
					text: [{
						required: true,
						message: '请输入密钥',
						trigger: 'blur'
					}, {
						min: 16,
						max: 16,
						message: '长度需为16个字符',
						trigger: 'blur'
					}],
				}
			}
		},
		created() {

		},
		mounted() {
			this.getGardens()
		},
		watch: {
			gardenId(newVal) {
				let current = this.gardenList.find(function (val) {
					return val.id == newVal
				})
				this.gardenName = current.name
			}
		},
		methods: {
			// 获取园区列表
			getGardens() {
				let that = this
				this.$get(`/gardens`).then(
					res => {
						if (res && res.errCode === 0) {
							that.gardenList = res.list
							let current = that.gardenList.find(function (value) {
								return value.id == that.$store.getters.gardenId
							})
							that.gardenId = current ? current.id : null
							that.getSecretByGarden()
						}
					},
					error => {
						this.$message.error(error)
					}
				)
			},
			onChangeGarden(item) {
				this.getSecretByGarden()
			},
			// 获取园区密钥
			getSecretByGarden() {
				if (!this.gardenId) {
					return
				}
				this.$get(`/xl/token/load?gardenId=${this.gardenId}`).then(
					res => {
						if (res && res.errCode === 0) {
							this.secret = res.res
							this.ruleForm.text = this.secret ? this.secret.secret : null
						}
					},
					error => {
						this.$message.error(error)
					}
				)
			},
			// 显示保存弹窗
			showDialog(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					}
				})
			},
			// 保存密钥
			saveSecretByGarden() {
				if (!this.gardenId && !this.ruleForm.text) {
					return
				}
				let params = {
					gardenId: this.gardenId,
					secret: this.ruleForm.text
				}
				let path = this.secret ? '/xl/token/update' : '/xl/token/add'
				this.$post(path, params).then(
					res => {
						if (res && res.errCode === 0) {
							this.dialogVisible = false
							this.disabled = true
							this.getSecretByGarden()
						}
					},
					error => {
						this.$message.error(error)
					}
				)
			},
			cancel() {
				this.$refs.ruleForm.clearValidate()
				this.ruleForm.text = this.secret ? this.secret.secret : null
				this.disabled = true
			}
		}
	}
</script>

<style lang="scss">
	.xlSecretManage {
		.formBox {
			display: flex;
			margin-top: 20px;
		}

		.el-form-item__label{
			width: 120px;
		}

		.el-form-item__content {
			display: flex;
		}

		.el-input {
			margin-right: 20px;
		}

		.c-red {
			color: red;
			// width: 240px;
			// text-align: right;
			display: inline-block;
			margin-left: 38px;
		}
	}
</style>